<template>
  <div>
    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin -->

    <v-card class="box" v-if="child_list !=null">
    
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title class="mr-4">
              <strong>Request Bonafide Certificate </strong></v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <span style="width: 20px"></span>
          <br>
          <v-row justify="center" dense>
              <v-col cols="12" sm="3" md="3">
                  <v-autocomplete
                    rounded
                    outlined
                    dense
                    v-model="child_data"
                    :items="child_list"
                    item-text="name"
                    label="Select child"
                    return-object
                    @change="getBonofideRequestStatus"
                  ></v-autocomplete>
              </v-col>
          </v-row>
          <template v-if="child_data!=null && status_flag">
          <v-row justify="center" dense>
            <v-col cols="12" sm="3" md="3">
              <v-text-field label="Enter Name"  rounded outlined dense v-model.trim="child_data.name" :rules="[(v) => !!v || 'required']" ></v-text-field
            ></v-col>
            <v-col cols="12" sm="3" md="3"
              >
              <v-text-field  label="Enter Address"  rounded outlined dense v-model.trim="child_data.laddress" :rules="[(v) => !!v || 'required']"></v-text-field></v-col>
          <!-- </v-row> -->

          <!-- <v-row dense justify="center"> -->
            <v-col cols="12" sm="3" md="3">
                <v-text-field  label="Enter DoB"  rounded outlined dense v-model.trim="child_data.dob" :rules="[(v) => !!v || 'required']"></v-text-field>
              </v-col>
          </v-row>

          <v-row justify="center" dense>
            <v-col cols="12" sm="3" md="3">
              <v-text-field  rounded outlined  dense label="Enter Place of Birth" v-model.trim="child_data.birth_place" ></v-text-field
            ></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field  rounded outlined dense label="Enter Caste (if applicable)" v-model.trim="child_data.caste"  ></v-text-field
            ></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-btn  @click="requestBonafide()" class="button">Proceed </v-btn>
            </v-col>
          </v-row>
          </template>

    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    child_data:null,
    child_list:null,
    status_flag:false
    ///////////////////////////////////////////////
  }),
  
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },

     async call() {
      try {
        const res = await axios.post("/parentDashboard/childProfileComponent");
        if (res.data.flag == "YES") {
          this.child_list = res.data.child_data;
          this.$store.commit("setchild_data", this.child_data);
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
      } finally {
        console.log("bye...");
      }
    },

    async getBonofideRequestStatus() {
      const formdata = {
        child_id:this.child_data.lid
      }
      this.status_flag = false
      try {
        const res = await axios.post("/parent/getBonofideRequestStatus", formdata);
        if (res.data.flag == "YES") {
          this.status_flag = true
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
      } finally {
        console.log("bye...");
      }
    },

    async requestBonafide() {
      const formdata = {
        child_id: this.child_data.lid,
        name: this.child_data.name,
        birth_place: this.child_data.birth_place,
        laddress: this.child_data.laddress,
        dob: this.child_data.dob,
        caste: this.child_data.caste
      }
      try {
        const res = await axios.post("/parent/requestBonafide", formdata);
        if (res.data.flag == "YES") {
          this.showSnackbar("green", res.data.snackbar);
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
      } finally {
        console.log("bye...");
      }
    },

  },
  created(){
    this.child_list = this.$store.state.child_data
  },
  mounted() {
    
    if(this.child_list ==null)
      this.call();
  },
};
</script>